// Tannic Lab theme v2

(function() {
  'use strict';

  // === AGE GATE ===
  // Uses sessionStorage so the gate only appears once per browser session
  function initAgeGate() {
    const gate = document.querySelector('[data-age-gate]');
    if (!gate) return;
    const verified = sessionStorage.getItem('tl_age_verified') === 'yes';
    if (verified) {
      gate.remove();
      document.body.classList.remove('age-gate-open');
      return;
    }
    document.body.classList.add('age-gate-open');
    const yes = gate.querySelector('[data-age-yes]');
    const no = gate.querySelector('[data-age-no]');
    const question = gate.querySelector('[data-age-question]');
    const denied = gate.querySelector('[data-age-denied]');
    if (yes) yes.addEventListener('click', function() {
      sessionStorage.setItem('tl_age_verified', 'yes');
      gate.classList.add('hidden');
      document.body.classList.remove('age-gate-open');
      setTimeout(function() { gate.remove(); }, 400);
    });
    if (no) no.addEventListener('click', function() {
      if (question) question.style.display = 'none';
      if (denied) denied.classList.add('show');
    });
  }
  initAgeGate();

  // Mobile nav toggle
  const toggle = document.querySelector('.tl-mobile-toggle');
  const nav = document.querySelector('.tl-nav');
  if (toggle && nav) {
    toggle.addEventListener('click', function() {
      nav.classList.toggle('open');
      const expanded = nav.classList.contains('open');
      toggle.setAttribute('aria-expanded', expanded);
      toggle.innerHTML = expanded ? '&times;' : '&#9776;';
    });
  }

  // Reveal category sections on scroll
  const observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) entry.target.classList.add('visible');
    });
  }, { threshold: 0.1 });
  document.querySelectorAll('[data-reveal]').forEach(function(el) { observer.observe(el); });

  // Product gallery thumbnail swap
  const mainImage = document.querySelector('[data-product-main-image]');
  const thumbs = document.querySelectorAll('[data-product-thumb]');
  if (mainImage && thumbs.length) {
    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        const fullSrc = thumb.getAttribute('data-full-src');
        if (fullSrc) {
          mainImage.src = fullSrc;
          thumbs.forEach(function(t) { t.classList.remove('active'); });
          thumb.classList.add('active');
        }
      });
    });
  }

  // Quantity buttons
  document.querySelectorAll('[data-qty-wrap]').forEach(function(wrap) {
    const input = wrap.querySelector('input[type="number"]');
    const minus = wrap.querySelector('[data-qty-minus]');
    const plus = wrap.querySelector('[data-qty-plus]');
    if (!input) return;
    if (minus) minus.addEventListener('click', function() {
      const v = parseInt(input.value, 10) || 1;
      if (v > 1) input.value = v - 1;
    });
    if (plus) plus.addEventListener('click', function() {
      input.value = (parseInt(input.value, 10) || 1) + 1;
    });
  });

  // Variant selector
  const variantSelect = document.querySelector('[data-variant-select]');
  const priceEl = document.querySelector('[data-product-price]');
  const compareEl = document.querySelector('[data-product-compare]');
  if (variantSelect && priceEl) {
    variantSelect.addEventListener('change', function() {
      const opt = variantSelect.options[variantSelect.selectedIndex];
      const price = opt.getAttribute('data-price');
      const compare = opt.getAttribute('data-compare-price');
      const available = opt.getAttribute('data-available') === 'true';
      if (price) priceEl.textContent = price;
      if (compareEl) {
        if (compare && compare !== price) {
          compareEl.textContent = compare;
          compareEl.style.display = 'inline';
        } else {
          compareEl.style.display = 'none';
        }
      }
      const submitBtn = document.querySelector('[data-add-to-cart]');
      if (submitBtn) {
        if (available) {
          submitBtn.disabled = false;
          submitBtn.textContent = submitBtn.getAttribute('data-text-add');
        } else {
          submitBtn.disabled = true;
          submitBtn.textContent = submitBtn.getAttribute('data-text-soldout');
        }
      }
    });
  }
})();
